import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CREDIT_CARD: GlameraIconDefinition = {
  name: 'credit-card',
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
  svg: `
    <path class="glm-credit-card-body" d="M2.25 8.25h19.5M2.25 9h19.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"></path>
    <path class="glm-credit-card-line glm-credit-card-line-1" d="M5.25 14.25h6"></path>
    <path class="glm-credit-card-line glm-credit-card-line-2" d="M5.25 16.5h3"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-credit-card-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './credit-card.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CreditCardIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CREDIT_CARD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
